import { ShoppingBag, Phone, Navigation } from "lucide-react";
import { SITE } from "@/lib/config";
import { useLang } from "@/lib/i18n";
import { trackEvent } from "@/lib/analytics";

export const MobileActionBar = () => {
  const { t } = useLang();
  const items = [
    { key: "order", href: SITE.orderUrl, icon: ShoppingBag, label: t("actions.order"), event: "order_click", external: true, primary: true },
    { key: "call", href: `tel:${SITE.phoneE164}`, icon: Phone, label: t("actions.call"), event: "phone_click" },
    { key: "directions", href: SITE.directionsUrl, icon: Navigation, label: t("actions.directions"), event: "directions_click", external: true },
  ];
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-hacienda-white/95 backdrop-blur-md border-t border-hacienda-border-light pb-[env(safe-area-inset-bottom)]"
      aria-label="Quick actions"
      data-testid="mobile-action-bar"
    >
      <div className="grid grid-cols-3">
        {items.map(({ key, href, icon: Icon, label, event, external, primary }) => (
          <a
            key={key}
            href={href}
            {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            onClick={() => trackEvent(event, { location: "mobile_bar" })}
            className={`flex flex-col items-center justify-center gap-1 py-2.5 text-xs font-semibold transition-colors ${primary ? "bg-hacienda-terracotta text-white" : "text-hacienda-charcoal hover:text-hacienda-terracotta"}`}
            data-testid={`mobile-bar-${key}`}
          >
            <Icon size={20} aria-hidden="true" />
            {label}
          </a>
        ))}
      </div>
    </nav>
  );
};
